import React, { useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { TINYMCE_API_KEY } from "../../config";

const allPlugins = [
  "preview",
  "anchor",
  "autolink",
  "charmap",
  "codesample",
  "emoticons",
  "image",
  "link",
  "lists",
  "media",
  "searchreplace",
  "table",
  "visualblocks",
  "wordcount",
  "linkchecker",
  "code",
];

const allToolbar = [
  "preview undo redo blocks fontfamily fontsize forecolor backcolor bold italic underline strikethrough link image media table align lineheight numlist bullist indent outdent emoticons charmap removeformat",
];

const TinyMceEditorComponent = ({ error = null, initialValue, handleBlur, handleChange = null, disablePlugins = [], tokens = [], isDisabled = false }) => {
  const defaultPlugins = allPlugins.filter((plugin) => !disablePlugins.includes(plugin));

  const [content, setContent] = useState(initialValue);
  const [selectedTag, setSelectedTag] = useState("");
  const editorRef = useRef(null);

  const handleEditorBlur = () => {
    handleBlur(content);
  };

  const handleInsertToken = (selectedOption) => {
    if (editorRef.current && selectedOption) {
      const labelHtml = `<span contenteditable="false">{{${selectedOption}}}</span>&nbsp;`;
      editorRef.current.insertContent(labelHtml);
    }
  };

  const handleEditorChange = (newContent) => {
    setContent(newContent);
    if (handleChange) {
      handleChange(newContent);
    }
  };

  const handleSelectChange = (event) => {
    const val = event.target.value;
    setSelectedTag(val);
    handleInsertToken(val);
  };

  const handleMenuItemClick = (val) => {
    if (val === selectedTag) handleInsertToken(val);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Editor
        onInit={(evt, editor) => (editorRef.current = editor)}
        apiKey={TINYMCE_API_KEY}
        value={content}
        onEditorChange={handleEditorChange}
        onBlur={handleEditorBlur}
        disabled={isDisabled}
        init={{
          script_url: "./../../utils/tinymce/tinymce.min.js",
          plugins: defaultPlugins.join(" "),
          toolbar: allToolbar.join(" "),
          // images_upload_handler: uploadMedia,
        }}
      />
      {error && (
        <Typography
          variant="body2"
          color="error"
          sx={{ mt: 1 }}
        >
          {error}
        </Typography>
      )}

      {Array.isArray(tokens) && tokens.length > 0 && (
        <FormControl
          fullWidth
          sx={{ mt: 2, width: "50%" }}
          disabled={isDisabled}
        >
          <InputLabel id="mergeTagsList">Tags</InputLabel>
          <Select
            labelId="mergeTagsList"
            id="mergeTagsList"
            value={selectedTag}
            label="Tags"
            onChange={handleSelectChange}
          >
            {tokens.map((tag, idx) => (
              <MenuItem
                key={idx}
                value={tag.value}
                onClick={() => handleMenuItemClick(tag.value)}
              >
                {tag.label}
              </MenuItem>
            ))}
          </Select>
          {tokens.length === 0 && <FormHelperText>No merge tags available</FormHelperText>}
        </FormControl>
      )}
    </Box>
  );
};

export default TinyMceEditorComponent;
